module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ViNTUwNTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmV4Y2xhbWF0aW9uLW9yYW5nZTwvdGl0bGU+PHBhdGggY2xhc3M9ImEiIGQ9Ik0yMSwxNy4xMmwxLjYsMTMuMWgyLjg2TDI3LDE3LjEyVjEwSDIxdjcuMTJoMFpNMjEuMTMsMzhoNS43M1YzMi40OUgyMS4xM1YzOFpNMjQsNEEyMCwyMCwwLDEsMSw0LDI0LDIwLDIwLDAsMCwxLDI0LDRtMC00QTI0LDI0LDAsMSwwLDQ4LDI0LDI0LDI0LDAsMCwwLDI0LDBoMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/exclamation-orange.svg
// module id = C7yN
// module chunks = 0